export default function campaignDeliveryPoints(state = [], action) {
  switch (action.type) {
    case 'UPDATE_CAMPAIGNS_DELIVERY_POINTS':
      return action.deliveryPoints.message
        ? action.deliveryPoints
        : action.deliveryPoints.deliveryPoints;

    case 'LOGOUT':
      return [];

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/campaignDeliveryPoints.js